/* Hero Product Section — responsive, dependency-free behavior. */
(function () {
  'use strict';

  if (window.__heroProductSectionLoaded) {
    if (typeof window.__initHeroProductSections === 'function') {
      window.__initHeroProductSections();
    }
    return;
  }
  window.__heroProductSectionLoaded = true;

  function initHeroProduct(root) {
    if (!root || root.getAttribute('data-hero-initialized') === 'true') return;
    root.setAttribute('data-hero-initialized', 'true');

    var cleanups = [];

    function listen(target, eventName, callback, options) {
      if (!target) return;
      target.addEventListener(eventName, callback, options);
      cleanups.push(function () {
        target.removeEventListener(eventName, callback, options);
      });
    }

    var dataElement = root.querySelector('[data-hero-product-json]');
    var data = null;
    try {
      data = dataElement ? JSON.parse(dataElement.textContent) : null;
    } catch (error) {
      data = null;
    }

    var currency = (data && data.currency) || 'USD';
    var locale = (data && data.locale) || document.documentElement.lang || undefined;
    var moneyFormatter;

    try {
      moneyFormatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      });
    } catch (error) {
      moneyFormatter = null;
    }

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      return moneyFormatter ? moneyFormatter.format(amount) : '$' + amount.toFixed(2);
    }

    var form = root.querySelector('[data-hero-form]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var qtyInput = form ? form.querySelector('[data-hero-qty-input]') : null;
    var atcButton = root.querySelector('[data-hero-atc]');
    var sticky = root.querySelector('[data-hero-sticky]');
    var stickyButton = root.querySelector('[data-hero-sticky-atc]');
    var stickyPrice = root.querySelector('[data-hero-sticky-price]');
    var sellingPlanInput = form ? form.querySelector('[data-hero-selling-plan]') : null;
    var saveLabel = root.getAttribute('data-save-label') || 'Save';

    var currentVariant =
      data && data.variants
        ? data.variants.find(function (variant) {
            return idInput && String(variant.id) === String(idInput.value);
          }) || data.variants[0]
        : null;

    /* Third-party bundle placement
       Kaching and similar apps often inject at the start of the first product form.
       Move the complete top-level widget into our intentional slot without cloning it,
       so the app's event listeners and checkout behavior remain attached. */
    var appBundleSlot = form ? form.querySelector('[data-hero-app-bundle-slot]') : null;
    var relocationFrame = null;
    var relocationTimers = [];

    function topLevelFormChild(node) {
      if (!form || !node || (appBundleSlot && appBundleSlot.contains(node))) return null;
      var candidate = node;
      while (candidate.parentElement && candidate.parentElement !== form) {
        candidate = candidate.parentElement;
      }
      return candidate.parentElement === form ? candidate : null;
    }

    function isProtectedFormChild(element) {
      return element.matches(
        '[data-hero-theme-price], [data-hero-main-price], [data-hero-variants], ' +
          '[data-hero-app-bundle-slot], .hero-product__features, .hero-product__stock, ' +
          '.hero-product__offers, .hero-product__refill, .hero-product__qty, ' +
          '.hero-product__atc, input[type="hidden"], script'
      );
    }

    function relocateThirdPartyBundles() {
      relocationFrame = null;
      if (!form || !appBundleSlot) return;

      var candidates = [];
      var candidateSet = new Set();
      var markerSelector = [
        'kaching-bundle',
        'kaching-subscriptions',
        'pumper-bundle',
        '[data-kaching-bundle]',
        '[data-kaching-subscriptions]',
        '[class*="kaching-bundle"]',
        '[id*="kaching-bundle"]',
        '[class*="pumper"]',
        '[id*="pumper"]',
        '[class*="bundle-widget"]',
        '[id*="bundle-widget"]',
        '[class*="quantity-break"]',
        '[id*="quantity-break"]'
      ].join(',');

      Array.prototype.slice.call(form.querySelectorAll(markerSelector)).forEach(function (marker) {
        var candidate = topLevelFormChild(marker);
        if (candidate && !isProtectedFormChild(candidate) && !candidateSet.has(candidate)) {
          candidateSet.add(candidate);
          candidates.push(candidate);
        }
      });

      /* Fallback for apps with generated class names: only consider an unknown direct
         form child when its visible content strongly resembles a bundle/subscription. */
      Array.prototype.slice.call(form.children).forEach(function (child) {
        if (child === appBundleSlot || isProtectedFormChild(child) || candidateSet.has(child)) return;

        var text = (child.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        var radioCount = child.querySelectorAll('input[type="radio"]').length;
        var checkboxCount = child.querySelectorAll('input[type="checkbox"]').length;
        var resemblesBundle = radioCount >= 2 && /(bundle|quantity|buy\s*\d|save\s*\d)/i.test(text);
        var resemblesSubscription = checkboxCount >= 1 && /(subscribe|subscription).*save/i.test(text);

        if (resemblesBundle || resemblesSubscription) {
          candidateSet.add(child);
          candidates.push(child);
        }
      });

      candidates.sort(function (a, b) {
        return Array.prototype.indexOf.call(form.children, a) - Array.prototype.indexOf.call(form.children, b);
      });

      candidates.forEach(function (candidate) {
        appBundleSlot.appendChild(candidate);
      });
    }

    function scheduleBundleRelocation() {
      if (relocationFrame !== null || !appBundleSlot) return;
      relocationFrame = window.requestAnimationFrame(relocateThirdPartyBundles);
    }

    if (form && appBundleSlot && 'MutationObserver' in window) {
      var bundleObserver = new MutationObserver(scheduleBundleRelocation);
      bundleObserver.observe(form, { childList: true, subtree: true });
      cleanups.push(function () {
        bundleObserver.disconnect();
      });
    }

    scheduleBundleRelocation();
    [250, 1000, 3000].forEach(function (delay) {
      var timer = window.setTimeout(scheduleBundleRelocation, delay);
      relocationTimers.push(timer);
    });
    cleanups.push(function () {
      if (relocationFrame !== null) window.cancelAnimationFrame(relocationFrame);
      relocationTimers.forEach(window.clearTimeout);
    });

    /* Gallery */
    var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-hero-media]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hero-thumb]'));
    var thumbTrack = root.querySelector('.hero-product__thumbs');
    var activeMediaIndex = 0;

    function activateMedia(index, scrollThumb) {
      var nextIndex = Math.max(0, Math.min(Number(index) || 0, mediaItems.length - 1));
      activeMediaIndex = nextIndex;

      mediaItems.forEach(function (item, itemIndex) {
        var active = itemIndex === nextIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
        var video = item.querySelector('video');
        if (video && !active) video.pause();
      });

      thumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === nextIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (scrollThumb && thumbTrack && thumbs[nextIndex]) {
        var selectedThumb = thumbs[nextIndex];
        var left = selectedThumb.offsetLeft - (thumbTrack.clientWidth - selectedThumb.offsetWidth) / 2;
        thumbTrack.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (thumb) {
      listen(thumb, 'click', function () {
        activateMedia(thumb.getAttribute('data-hero-thumb'), true);
      });
    });

    var mediaMain = root.querySelector('.hero-product__media-main');
    var touchStartX = null;
    listen(
      mediaMain,
      'touchstart',
      function (event) {
        if (event.touches.length === 1) touchStartX = event.touches[0].clientX;
      },
      { passive: true }
    );
    listen(
      mediaMain,
      'touchend',
      function (event) {
        if (touchStartX === null || !event.changedTouches.length || mediaItems.length < 2) return;
        var distance = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) < 45) return;
        activateMedia(distance < 0 ? activeMediaIndex + 1 : activeMediaIndex - 1, true);
      },
      { passive: true }
    );

    function activateVariantMedia(variant) {
      if (!variant || !variant.featured_media_id) return;
      var mediaIndex = mediaItems.findIndex(function (item) {
        return String(item.getAttribute('data-media-id')) === String(variant.featured_media_id);
      });
      if (mediaIndex >= 0) activateMedia(mediaIndex, true);
    }

    activateMedia(0, false);

    /* Bundle offers */
    var offers = Array.prototype.slice.call(root.querySelectorAll('[data-hero-offer]'));

    function refreshOfferPrices() {
      if (!currentVariant) return;

      offers.forEach(function (offer) {
        if (offer.getAttribute('data-auto-price') !== 'true') return;

        var quantity = parseInt(offer.getAttribute('data-qty'), 10) || 1;
        var discount = parseInt(offer.getAttribute('data-discount'), 10) || 0;
        var lineTotal = currentVariant.price * quantity;
        var finalPrice = Math.floor((lineTotal * (100 - discount)) / 100);
        var anchorUnit =
          currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price
            ? currentVariant.compare_at_price
            : currentVariant.price;
        var anchorTotal = anchorUnit * quantity;
        var priceElement = offer.querySelector('[data-offer-price]');
        var compareElement = offer.querySelector('[data-offer-compare]');
        var saveElement = offer.querySelector('[data-offer-save]');

        if (priceElement) priceElement.textContent = formatMoney(finalPrice);

        if (compareElement) {
          compareElement.textContent = formatMoney(anchorTotal);
          compareElement.hidden = anchorTotal <= finalPrice;
        }

        if (saveElement) {
          var savings = anchorTotal > finalPrice ? Math.round(100 - (finalPrice * 100) / anchorTotal) : 0;
          saveElement.textContent = saveLabel + ' ' + savings + '%';
          saveElement.hidden = savings <= 0;
        }
      });
    }

    function selectedOffer() {
      return root.querySelector('[data-hero-offer].is-selected');
    }

    function selectedQuantity() {
      var offer = selectedOffer();
      if (offer) return parseInt(offer.getAttribute('data-qty'), 10) || 1;
      return parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
    }

    function updateStickyPrice() {
      if (!stickyPrice) return;
      var offer = selectedOffer();
      var offerPrice = offer ? offer.querySelector('[data-offer-price]') : null;

      if (offerPrice) {
        stickyPrice.textContent = offerPrice.textContent;
      } else if (currentVariant) {
        stickyPrice.textContent = formatMoney(currentVariant.price * selectedQuantity());
      }
    }

    function selectOffer(offer) {
      offers.forEach(function (item) {
        var radio = item.querySelector('input[type="radio"]');
        var selected = item === offer;
        item.classList.toggle('is-selected', selected);
        if (radio) radio.checked = selected;
      });

      if (qtyInput) qtyInput.value = parseInt(offer.getAttribute('data-qty'), 10) || 1;
      updateStickyPrice();
    }

    offers.forEach(function (offer) {
      var radio = offer.querySelector('input[type="radio"]');
      listen(radio, 'change', function () {
        if (radio.checked) selectOffer(offer);
      });
    });

    /* Variant picker and dynamic price */
    var variantInputs = Array.prototype.slice.call(
      root.querySelectorAll('[data-hero-variant-input], [data-hero-variant-select]')
    );
    var selectedOptionLabels = Array.prototype.slice.call(root.querySelectorAll('[data-hero-option-selected]'));
    var mainPrice = root.querySelector('[data-hero-main-price]');
    var mainCompare = root.querySelector('[data-hero-main-compare]');
    var themePrice = root.querySelector('[data-hero-theme-price]');

    function updateThemePrice(variant) {
      if (!themePrice || !variant) return;

      var priceRoot = themePrice.querySelector('.price') || themePrice;
      var regularPrice = themePrice.querySelector('.price__regular .price-item--regular');
      var salePrice = themePrice.querySelector('.price__sale .price-item--sale');
      var comparePrice = themePrice.querySelector('.price__sale .price-item--regular');
      var saleBadge = themePrice.querySelector('.price__badge-sale');
      var soldOutBadge = themePrice.querySelector('.price__badge-sold-out');
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (regularPrice) regularPrice.textContent = formatMoney(variant.price);
      if (salePrice) salePrice.textContent = formatMoney(variant.price);
      if (comparePrice) comparePrice.textContent = formatMoney(variant.compare_at_price || variant.price);

      priceRoot.classList.toggle('price--on-sale', Boolean(onSale));
      priceRoot.classList.toggle('price--sold-out', !variant.available);

      if (saleBadge) {
        var savings = onSale ? Math.round(100 - (variant.price * 100) / variant.compare_at_price) : 0;
        saleBadge.textContent = saveLabel + ' ' + savings + '%';
        saleBadge.hidden = !onSale;
      }
      if (soldOutBadge) soldOutBadge.hidden = variant.available;
    }

    function updatePurchaseButtons(variant) {
      var available = Boolean(variant && variant.available);
      var label = available
        ? (data && data.strings && data.strings.add_to_cart) || 'Add to cart'
        : (data && data.strings && data.strings.sold_out) || 'Sold out';

      [atcButton, stickyButton].forEach(function (button) {
        if (!button) return;
        button.disabled = !available;
        button.textContent = label;
      });
    }

    function updateSelectedOptionLabels(options) {
      selectedOptionLabels.forEach(function (label) {
        var optionIndex = parseInt(label.getAttribute('data-option-index'), 10);
        if (options[optionIndex] !== undefined) label.textContent = options[optionIndex];
      });
    }

    function applyVariant(variant, notify) {
      if (!variant) return;
      currentVariant = variant;

      if (idInput) {
        idInput.value = variant.id;
        if (notify) idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (mainPrice) mainPrice.textContent = formatMoney(variant.price);
      if (mainCompare) {
        mainCompare.textContent = formatMoney(variant.compare_at_price || variant.price);
        mainCompare.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price);
      }

      updateSelectedOptionLabels(variant.options || []);
      updateThemePrice(variant);
      updatePurchaseButtons(variant);
      refreshOfferPrices();
      updateStickyPrice();
      activateVariantMedia(variant);

      if (notify && typeof CustomEvent === 'function') {
        root.dispatchEvent(
          new CustomEvent('hero:variant-change', {
            bubbles: true,
            detail: { variant: variant }
          })
        );
      }
    }

    function unavailableState() {
      var label = (data && data.strings && data.strings.unavailable) || 'Unavailable';
      [atcButton, stickyButton].forEach(function (button) {
        if (!button) return;
        button.disabled = true;
        button.textContent = label;
      });
    }

    function onVariantChange() {
      if (!data || !data.variants) return;

      var chosenOptions = [];
      variantInputs.forEach(function (input) {
        if (input.type === 'radio' && !input.checked) return;
        chosenOptions[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      updateSelectedOptionLabels(chosenOptions);

      var match = data.variants.find(function (variant) {
        return variant.options.every(function (option, optionIndex) {
          return chosenOptions[optionIndex] === undefined || chosenOptions[optionIndex] === option;
        });
      });

      if (match) applyVariant(match, true);
      else unavailableState();
    }

    variantInputs.forEach(function (input) {
      listen(input, 'change', onVariantChange);
    });

    /* Quantity */
    Array.prototype.slice.call(root.querySelectorAll('[data-hero-qty-btn]')).forEach(function (button) {
      listen(button, 'click', function () {
        if (!qtyInput) return;
        var direction = button.getAttribute('data-hero-qty-btn') === 'plus' ? 1 : -1;
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + direction);
        updateStickyPrice();
      });
    });
    listen(qtyInput, 'change', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      updateStickyPrice();
    });

    /* Subscription */
    var refillCheckbox = root.querySelector('[data-hero-refill]');
    if (refillCheckbox && sellingPlanInput) {
      sellingPlanInput.disabled = !refillCheckbox.checked;
      listen(refillCheckbox, 'change', function () {
        sellingPlanInput.disabled = !refillCheckbox.checked;
      });
    }

    /* Sticky add-to-cart */
    function setStickyVisible(visible) {
      if (!sticky) return;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      root.classList.toggle('has-sticky-visible', visible);
      if (stickyButton) stickyButton.tabIndex = visible ? 0 : -1;
    }

    if (sticky && atcButton && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var buttonIsAboveViewport = entry.boundingClientRect.top < 0;
            setStickyVisible(!entry.isIntersecting && buttonIsAboveViewport);
          });
        },
        { threshold: 0 }
      );
      observer.observe(atcButton);
      cleanups.push(function () {
        observer.disconnect();
      });
    }

    listen(stickyButton, 'click', function () {
      if (!form || stickyButton.disabled) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(atcButton);
      else if (atcButton) atcButton.click();
    });

    /* Initial state */
    refreshOfferPrices();
    var checkedOfferInput = root.querySelector('[data-hero-offer] input:checked');
    var checkedOffer = checkedOfferInput ? checkedOfferInput.closest('[data-hero-offer]') : null;
    var preselectedOffer =
      root.querySelector('[data-hero-offer][data-preselected="true"]') || checkedOffer || offers[0];
    if (preselectedOffer) selectOffer(preselectedOffer);
    if (currentVariant) applyVariant(currentVariant, false);
    updateStickyPrice();
    setStickyVisible(false);

    root.__destroyHeroProduct = function () {
      cleanups.forEach(function (cleanup) {
        cleanup();
      });
      root.removeAttribute('data-hero-initialized');
      delete root.__destroyHeroProduct;
    };
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-hero-product]')).forEach(initHeroProduct);
  }

  window.__initHeroProductSections = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.matches && event.target.matches('[data-hero-product]')
      ? event.target
      : event.target.querySelector('[data-hero-product]');
    if (root) initHeroProduct(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches('[data-hero-product]')
      ? event.target
      : event.target.querySelector('[data-hero-product]');
    if (root && typeof root.__destroyHeroProduct === 'function') root.__destroyHeroProduct();
  });
})();
